import React from 'react'
import { useScrollAnimation } from '../hooks/useScrollAnimation'

interface Testimonial {
  id: number
  name: string
  city: string
  text: string
  rating: number
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'María García',
    city: 'Bogotá',
    text: 'La calidad de la ropa es excelente. Mis hijos se sienten cómodos todo el día y los diseños son modernos y bonitos. ¡Muy recomendado!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Juan Rodríguez',
    city: 'Medellín',
    text: 'Excelente servicio y atención. Las prendas duran mucho y combaten bien el lavado. He comprado varias veces y siempre estoy satisfecho.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Carolina López',
    city: 'Cali',
    text: 'Jenny Kids es mi marca favorita para vestir a mis pequeños. La variedad de estilos es increíble y los precios son justos.',
    rating: 5,
  },
]

const Testimonials: React.FC = () => {
  const { ref, isVisible } = useScrollAnimation()

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="container-max">
        <div
          ref={ref}
          className={`text-center mb-12 ${
            isVisible ? 'animate-fade-in-up' : ''
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Lo que dicen nuestros clientes
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            La satisfacción de nuestros clientes es lo más importante. Aquí algunos de sus testimonios.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`bg-gray-50 rounded-lg p-6 ${
                isVisible ? 'animate-fade-in-up' : ''
              }`}
              style={isVisible ? { animationDelay: `${index * 100}ms` } : {}}
            >
              {/* Avatar with initials */}
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full flex items-center justify-center text-white font-bold text-lg mr-4">
                  {testimonial.name
                    .split(' ')
                    .map((n) => n[0])
                    .join('')}
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.city}</p>
                </div>
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <span key={i} className="text-yellow-400 text-lg">
                    ⭐
                  </span>
                ))}
              </div>

              {/* Review text */}
              <p className="text-gray-700 leading-relaxed">"{testimonial.text}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Testimonials
